import React from 'react';
import { Store } from '@/lib/types';
import { getStoresByStateAndCity } from '@/lib/utils';
import {
  Card,
  CardContent
} from "@geely/ui";
import { MapPin, Phone } from 'lucide-react';

interface StoreSelectorProps {
  stores: Store[];
  selectedState: string;
  selectedCity: string;
  selectedStoreId: string;
  onSelectStore: (storeId: string) => void;
}

export function StoreSelector({
  stores,
  selectedState,
  selectedCity,
  selectedStoreId,
  onSelectStore
}: StoreSelectorProps) {
  const filteredStores = getStoresByStateAndCity(stores, selectedState, selectedCity);

  return (
    <div className="space-y-3">
      <h3 className="font-medium text-[#080404]">Selecione a Loja</h3>
      <div className="grid grid-cols-1 gap-3">
        {filteredStores.map(store => {
          const isSelected = selectedStoreId === store.id;

          return (
            <Card
              key={store.id}
              className={`cursor-pointer transition-all hover:shadow-md ${
                isSelected
                  ? 'border-[#000000] border-2 bg-[#000000]/5'
                  : 'border-[#e2e8f0] hover:border-[#000000]/30'
              }`}
              onClick={() => onSelectStore(store.id)}
            >
              <CardContent className="p-4">
                <div className="flex items-start gap-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
                    isSelected ? 'bg-[#000000]' : 'bg-[#e2e8f0]'
                  }`}>
                    <MapPin className={`size-5 ${
                      isSelected ? 'text-white' : 'text-[#64748b]'
                    }`} />
                  </div>
                  <div className="flex-1">
                    <p className={`font-semibold mb-1 ${
                      isSelected ? 'text-[#000000]' : 'text-[#080404]'
                    }`}>
                      {store.name}
                    </p>
                    <p className="text-sm text-[#64748b] mb-2">
                      {store.street}, {store.number} - {store.neighborhood}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-[#64748b]">
                      <Phone className="size-3" />
                      <span>{store.phone}</span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
